import { useQuery } from '@tanstack/react-query';
import { listConnections } from '@/api/endpoints';
import type { Connection } from '@/api/types';

/**
 * Decides whether to force the onboarding wizard. We only flag it once the
 * connections query has resolved successfully — otherwise the empty array
 * from a still-loading query would bounce the user mid-load.
 */
export function useOnboardingGate() {
  const { data, isSuccess, isLoading } = useQuery<Connection[]>({
    queryKey: ['connections'],
    queryFn: listConnections,
  });
  const needsOnboarding = isSuccess && (data?.length ?? 0) === 0;
  return { needsOnboarding, isLoading, connections: data };
}
